import React from "react";

import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";
import RbScrollView from "components/RbScrollView";

function DocsScreen() {
  return (
    <RbFlexView direction="column">
      <RbFlexViewItem>
        <RbHeader title="Documentation" />
      </RbFlexViewItem>
      <RbFlexViewItem
        flex="1"
        bgcolor="custom.bg.100"
        borderTop={1}
        borderColor="custom.border.200"
      >
        <RbScrollView p={{ xs: 4, md: 10 }}>
          <Typography variant="body1">
            This project itselt is a documentation of screens and good
            practices. A Storybook site is provided to document and develop
            components.
          </Typography>
          <br />
          <br />
          <Link
            href="https://master--5f4170451eb651002295935d.chromatic.com"
            target="_blank"
          >
            Storybook documentation (in progress)
          </Link>
        </RbScrollView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

export default React.memo(DocsScreen);
